import "../../css/master.css";
import "../../css/app.css";
import "../../css/custom.css";
import MainComponent from "./main_component";

function AboutContactService() {

    return (
        <MainComponent />
    );
}
export default AboutContactService;